import { render, staticRenderFns } from "./BorrowerDetailPage.vue?vue&type=template&id=07680344&"
import script from "./BorrowerDetailPage.vue?vue&type=script&lang=js&"
export * from "./BorrowerDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports